
import { computed, defineComponent, ref } from 'vue'
import { useIndustryModule } from '@/modules/industries'
import { IndustriesRouteNames } from '@/router/routes-names'
import usePaginationHelper from '@/views/_shared/search-list/pagination-helper'
import { useRoute, useRouter } from 'vue-router'
import { Package } from '@/modules/packages'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { Industry } from '@/modules/industries/types'
import DeleteIndustryDialog from '@/components/industries/dialogs/delete-industry.vue'

export default defineComponent({
    name: 'view-industries-list',
    setup () {
        const $q = useQuasar()
        const { getIndustries, industries } = useIndustryModule()
        const { pagination } = usePaginationHelper('title')
        const route = useRoute()
        const router = useRouter()

        const compareFunctionForIdColumn = (a: string, b: string) => {
            return parseInt(a) - parseInt(b)
        }

        const industryColumns = ([
            { name: 'id', label: 'Id', field: 'id', sortable: true, sort: compareFunctionForIdColumn, align: 'left' },
            { name: 'name', label: 'Industry Name', field: 'name', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const filter = ref<string>('')

        const filteredIndustries = computed(() => {
            if (filter.value === '') {
                return industries.value
            }
            const regexp = new RegExp(filter.value, 'i')
            return industries.value.filter(industry => regexp.test(`${industry.name}`))
        })

        function onEditIndustry (evt: PointerEvent | null, props: Industry) {
            router.push({ name: IndustriesRouteNames.EDIT, params: { id: props.id }, query: { page: route.query.page } })
        }

        async function onDeleteIndustry (industryRow: Package) {
            $q.dialog({
                component: DeleteIndustryDialog,
                componentProps: {
                    industryId: industryRow.id,
                    industryName: industryRow.name
                }
            })
        }

        getIndustries()

        return {
            filteredIndustries,
            industryColumns,
            IndustriesRouteNames,
            pagination,
            filter,
            route,
            onEditIndustry,
            onDeleteIndustry
        }
    }
})

